export default __webpack_public_path__ + "static/media/228.0451e82c.jpg";